
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDeleteGoogle as ObiDeleteGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-delete-google.js';
 
 
 

 
 export const ObiDeleteGoogle = createComponent({
   react: React,
   tagName: 'obi-delete-google',
   elementClass: ObiDeleteGoogleElement,
   events: {
     
   }
  });
 
 